module.exports = __webpack_public_path__ + "dc8c892a83b3543c79d908ff1e7561d1.jpg";